import { BeginCheckoutEventData } from '@/shared/thirdParty/gtm/types';
import { TCredit } from '@/shared/types/Billing';

import { getPricePerMin } from './getPricePerMin';

type GetBuyMinutesBeginCheckoutEventData = {
  price: number;
  product: TCredit;
  totalMinutes: number;
};

export const getBuyMinutesBeginCheckoutEventData = ({
  price,
  product,
  totalMinutes,
}: GetBuyMinutesBeginCheckoutEventData): BeginCheckoutEventData => {
  const { currency } = product.prices[0];
  return {
    ecommerce: {
      currency: currency.toUpperCase(),
      items: [
        {
          item_id: product.id,
          item_name: 'Minutes',
          price: getPricePerMin(product),
          price_id: product.prices[0].id,
          quantity: totalMinutes,
        },
      ],
      value: price,
    },
  };
};
